var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';

  let {
    topStoryData
  } = options;

__p+='\n\n';
 for(var i = 0; i < topStoryData.articles.length; i++) { var article = topStoryData.articles[i];
    var isVideo = article.type === 'video',
        imageSrc = MOVE.ARTICLE.Helper.largeThumbnail(article.featured_image && (article.featured_image.source_ngi || article.featured_image.source_mobile)),
        imageAlt = article.featured_image && article.featured_image.alt_text;
    if (article.seo_url && article.title) { 
__p+='\n<div class="article-card-container col-xs-12 col-sm-6 col-md-4">\n    <div class="article-card">\n        <div class="article-card-header">\n            ';
 if (article.category && article.category.name && article.category.link) { 
__p+='\n            <a data-omtag="web:article:top-stories:article" href="'+
((__t=( article.seo_url ))==null?'':__t)+
'">\n                <span class="news-category" data-category="'+
((__t=( MOVE.ARTICLE.Helper.slugify(article.category.name) ))==null?'':__t)+
'">\n                    '+
((__t=( article.category.name ))==null?'':__t)+
'\n                </span>\n            </a>\n            ';
 } 
__p+='\n        </div>\n        <div class="article-card-title-container">\n            <a class="article-card-title" data-omtag="web:article:top-stories:'+
((__t=( isVideo ? 'video' : 'article' ))==null?'':__t)+
'" href="'+
((__t=( article.seo_url ))==null?'':__t)+
'">\n                '+
((__t=( article.title ))==null?'':__t)+
'\n            </a>\n            ';
 if (!isVideo) { 
__p+='\n            '+
((__t=( MOVE.ARTICLE.Helper.getArticleAttribution(article.attribution) ))==null?'':__t)+
'\n            ';
 } 
__p+='\n        </div> <!-- article-card-title -->\n        ';
 if (imageSrc) { 
__p+='\n        <div class="pos-relative">\n            <a data-omtag="web:article:top-stories:article" href="'+
((__t=( article.seo_url ))==null?'':__t)+
'">\n                <img class="article-card-image" alt="'+
((__t=( imageAlt || article.title ))==null?'':__t)+
'" src="'+
((__t=( imageSrc ))==null?'':__t)+
'" data-pin-nopin="true" />\n                ';
 if (isVideo) { 
__p+='\n                <i class="play-button"></i>\n                ';
 } 
__p+='\n            </a>\n        </div> <!-- pos-relative -->\n        ';
 } 
__p+='\n    </div> <!-- article-card -->\n</div> <!-- col-xs-12 -->\n';
 }
}

if (topStoryData.attribution_data) {
    for (var j = 0; j < topStoryData.attribution_data.length; j++) { var attribution = topStoryData.attribution_data[j];
        if (attribution.third_party_url) { 
__p+='\n        <img src="'+
((__t=( attribution.third_party_url ))==null?'':__t)+
'" async alt="" class="no-show" height="1" width="1" />\n        ';
 }
    }
}

__p+='\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/news_advice_top_stories.jst.ejs